module.exports = __webpack_public_path__ + "img/randabstand-EC2-draufsicht.33f6bf02.jpg";